import { Avatar, Box, Grid, Stack, Typography } from "@mui/material";
import { MprcCard, MprcContainer, MprcJoinComponents } from "components";
import { IconButtonEdit } from "components/iconButtons";
import { DevPlanViewDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import { useSession } from "providers/SessionProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { DevPlanMediaView } from "views/lms/devPlan/Home/components/DevPlanMediaView";
import { EditDevPlanDialog } from "views/lms/devPlan/Home/Edit/EditDevPlan";
import { DevPlanCardStatus } from "views/lms/devPlan/Home/Edit/EditDevPlanView/DevPlanCardStatus";
import { OperationMode } from "views/lms/devPlan/Home/Edit/EditDevPlanView/EditDevPlanView";

interface IProps {
    viewData: DevPlanViewDto;
    mode: OperationMode;
    onChange: () => void;
}

export const DevPlanViewHeader: React.FC<IProps> = (props) => {

    const { viewData, mode, onChange } = props;
    const { user } = useSession();
    const { t } = useTranslation("lms");

    const [dialog, setDialog] = React.useState<React.ReactNode>(null);

    ///
    const handleEdit = () => {
        setDialog(
            <EditDevPlanDialog
                devPlanId={viewData.devPlanId}
                onClose={(success) => {
                    if (success != null && onChange) onChange();
                    setDialog(null);
                }}
            />
        );
    };

    ///
    const buildSubtitle = () => {
        var items: React.ReactNode[] = [];

        items.push(
            <Typography variant="caption">
                {t("DevPlan.Edit.View.Header.CreatedByText", { name: viewData.recordInfo.creator.userId == user.userId ? t("shared:Literal.You") : viewData.recordInfo.creator.name })}
            </Typography>
        );

        if (viewData.isReadonly) {
            items.push(
                <Typography variant="caption">
                    {t("DevPlan.Edit.View.Header.ReadonlyText", { name: viewData.readonlyBy })}
                </Typography>
            );
        }

        items.push(
            <Typography variant="caption">
                {t("DevPlan.Edit.View.Header.StartedOnText", { name: Formaters.performaDate(viewData.startedOn, { excludeTime: true }) })}
            </Typography>
        );

        if (viewData.completionDeadline) {
            items.push(
                <Typography variant="bodyNotice">
                    {t("DevPlan.Edit.View.Header.CompletionDeadlineText", { name: Formaters.performaDate(viewData.completionDeadline, { excludeTime: true, preposition: "none" }) })}
                </Typography>
            );
        } else {
            items.push(<Typography variant="caption">{t("DevPlan.Edit.View.Header.NoCompletionDeadlineText")}</Typography>);
        }

        return <Typography variant="caption" component="p" fontWeight="bold"><MprcJoinComponents components={items} separator={<span>&nbsp;&bull;&nbsp;</span>} /></Typography>;
    };

    return (
        <>
            {dialog}

            <MprcContainer>
                <Grid container spacing={2} width="100%" alignItems="stretch">
                    <Grid size="grow">
                        <MprcCard sx={{ paddingX: 4, paddingY: 2, minHeight: "150px" }}>
                            <Stack direction="column" spacing={1.5}>
                                <Grid container spacing={2} width="100%">
                                    <Grid>
                                        <Avatar
                                            src={viewData.thumbnailUrl}
                                            sx={(theme) => ({ width: 64, height: 64, backgroundColor: theme.palette.grey[200] })}
                                        />
                                    </Grid>
                                    <Grid size="grow">
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Typography variant="h3" component="p" color="muted">
                                                {viewData.name}
                                            </Typography>
                                            {mode == OperationMode.Edit && viewData.actions.canEdit &&
                                                <IconButtonEdit
                                                    size="small"
                                                    onClick={() => handleEdit()}
                                                />
                                            }
                                        </Stack>
                                        <Typography variant="body2" component="p" color="muted">
                                            {viewData.userName}
                                        </Typography>
                                        <Box marginTop={0.6}>
                                            {buildSubtitle()}
                                        </Box>
                                    </Grid>
                                </Grid>
                                {viewData.description && (
                                    <Grid>
                                        <Typography variant="subtitle1" component="p" color="muted">{viewData.description}</Typography>
                                    </Grid>
                                )}
                                {viewData.attach && (
                                    <Grid>
                                        <DevPlanMediaView attach={viewData.attach} />
                                    </Grid>
                                )}
                            </Stack>
                        </MprcCard>
                    </Grid>
                    {
                        viewData.publishedOn != null &&
                        <Grid>
                            <DevPlanCardStatus viewData={viewData} />
                        </Grid>
                    }
                </Grid>
            </MprcContainer>
        </>
    );
};
